export default "__VITE_ASSET__DA4Tw4g7__"